/* ===== lp-v405-theme-core-generic.js ===== */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency', currency: 'EUR'
  }).format((cents || 0) / 100);

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const lines = document.querySelector('[data-cart-lines]');
  const total = document.querySelector('[data-cart-total]');

  function openCart() {
    if (!drawer) return;
    const opener = document.activeElement?.closest?.('[data-cart-open]') || document.querySelector('[data-cart-open]');
    if (opener) drawer._lpOpener = opener;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      overlay.style.pointerEvents = 'auto';
    }
    refreshCart();
    requestAnimationFrame(() => drawer.querySelector('[data-cart-close]')?.focus());
  }

  function closeCart({ restoreFocus = true } = {}) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.pointerEvents = 'none';
    }
    if (restoreFocus) {
      const opener = drawer._lpOpener || document.querySelector('[data-cart-open]');
      opener?.focus?.();
    }
  }

  async function refreshCart() {
    if (typeof lpRefreshPremiumCart === 'function') {
      await lpRefreshPremiumCart();
    }
  }

  async function addVariant(variantId, quantity = 1) {
    if (!variantId) return;
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!res.ok) throw new Error('Ajout panier impossible');
    openCart();
  }

  document.addEventListener('click', e => {
    const add = e.target.closest('.lp-add-quick');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      addVariant(add.dataset.variantId).catch(console.error).finally(() => add.disabled = false);
      return;
    }
    if (e.target.closest('[data-cart-open]')) openCart();
    if (e.target.closest('[data-cart-close]') || e.target === overlay) closeCart();

    if (e.target.closest('[data-mobile-menu-open]')) {
      const opener = e.target.closest('[data-mobile-menu-open]');
      const m = document.querySelector('[data-mobile-menu]');
      const b = document.querySelector('[data-mobile-menu-backdrop]');
      if (m) {
        opener?.setAttribute('aria-expanded', 'true');
        m.hidden = false;
        m.setAttribute('aria-hidden', 'false');
        if (b) {
          b.hidden = false;
          b.setAttribute('aria-hidden', 'false');
          b.style.pointerEvents = 'auto';
        }
        document.documentElement.classList.add('lp-menu-open');
        requestAnimationFrame(() => {
          m.classList.add('is-open');
          m.querySelector('[data-mobile-menu-close]')?.focus();
        });
      }
    }
    if (e.target.closest('[data-mobile-menu-close]') || e.target.closest('[data-mobile-menu-backdrop]')) {
      const m = document.querySelector('[data-mobile-menu]');
      const b = document.querySelector('[data-mobile-menu-backdrop]');
      if (m) {
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => { if (!m.classList.contains('is-open')) m.hidden = true; }, 320);
      }
      if (b) {
        b.setAttribute('aria-hidden', 'true');
        b.style.pointerEvents = 'none';
        window.setTimeout(() => { if (!document.documentElement.classList.contains('lp-menu-open')) b.hidden = true; }, 320);
      }
      document.documentElement.classList.remove('lp-menu-open');
      const opener = document.querySelector('[data-mobile-menu-open]');
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    }
  });

  /* V404 — cart drawer keyboard accessibility */
  document.addEventListener('keydown', e => {
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeCart();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')]
      .filter(el => !el.hidden && el.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

})();
async function lpRefreshPremiumCart() {
  try {
    const root = window.Shopify?.routes?.root || '/';
    const escapeHTML = (value='') => String(value).replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
    const safeUrl = (value='') => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        return url.origin === window.location.origin ? escapeHTML(url.pathname + url.search + url.hash) : '#';
      } catch { return '#'; }
    };
    const safeImage = (value='') => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        if (url.protocol !== 'https:' && url.origin !== window.location.origin) return '';
        return escapeHTML(url.href);
      } catch { return ''; }
    };
    const cartResponse = await fetch(`${root}cart.js`, { headers: { 'Accept':'application/json' } });
    if (!cartResponse.ok) throw new Error('Lecture du panier impossible');
    const cart = await cartResponse.json();

    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-menu-count]').forEach(el => {
      el.textContent = `(${cart.item_count})`;
      el.hidden = cart.item_count === 0;
    });

    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);

    const lines = document.querySelector('[data-cart-lines]');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<div class="lp-cart-drawer__empty"><span aria-hidden="true">◇</span><strong>Votre panier est vide.</strong><p>Découvrez la sélection LE PIONNEZ.</p><a href="' + root + '#parfums">Découvrir les parfums</a></div>';
      } else {
        lines.innerHTML = cart.items.map(item => {
          const itemUrl = safeUrl(item.url);
          const imageUrl = safeImage(item.image);
          const title = escapeHTML(item.product_title || '');
          const vendor = escapeHTML(item.vendor || '');
          const variant = escapeHTML(item.variant_title || '');
          const key = escapeHTML(item.key || '');
          const quantity = Math.max(0, Number(item.quantity) || 0);
          return `
          <div class="lp-cart-drawer__line">
            <a class="lp-cart-drawer__media" href="${itemUrl}">
              ${imageUrl ? `<img src="${imageUrl}" alt="${title}" loading="lazy">` : ''}
            </a>
            <div class="lp-cart-drawer__line-info">
              ${vendor ? `<span class="lp-cart-drawer__vendor">${vendor}</span>` : ''}
              <strong>${title}</strong>
              <span>${variant}</span>
              <div class="lp-cart-drawer__controls">
                <div class="lp-cart-qty" data-cart-qty data-line-key="${key}" data-quantity="${quantity}">
                  <button type="button" class="lp-cart-qty__btn" data-cart-qty-minus aria-label="Réduire la quantité">−</button>
                  <span class="lp-cart-qty__value" data-cart-qty-value aria-live="polite">${quantity}</span>
                  <button type="button" class="lp-cart-qty__btn" data-cart-qty-plus aria-label="Augmenter la quantité">+</button>
                </div>
                <button type="button" class="lp-cart-remove" data-cart-remove data-line-key="${key}">Supprimer</button>
              </div>
            </div>
            <strong>${money(item.final_line_price)}</strong>
          </div>`;
        }).join('');
      }
    }

    const checkoutForm = document.querySelector('[data-cart-checkout-form]');
    if (checkoutForm) checkoutForm.hidden = cart.item_count === 0;

    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);

    const progress = document.querySelector('[data-cart-progress]');
    if (progress) {
      progress.hidden = cart.item_count === 0;
      if (cart.item_count === 0) {
        progress.innerHTML = '';
      } else {
      const target = 20000;
      const remaining = Math.max(0, target - cart.total_price);
      const pct = Math.min(100, Math.round((cart.total_price / target) * 100));

      progress.innerHTML = `
        <div class="lp-cart-progress__text ${remaining === 0 ? 'lp-cart-progress__text--success' : ''}">
          ${remaining > 0 ? `Plus que <strong>${money(remaining)}</strong> pour la livraison offerte.` : 'Livraison offerte débloquée.'}
        </div>
        <div class="lp-cart-progress__bar"><span style="width:${pct}%"></span></div>
      `;
      }
    }
  } catch (e) {
    console.error('LE PIONNEZ premium cart refresh error', e);
  }
}

/* V405 — favoris chargés uniquement sur les pages qui les utilisent. */

/* V405 — comparateur chargé à la demande. */

/* V405 — ancien overlay Histoire global supprimé : aucun déclencheur actif dans les templates. */

/* V405 — panier global : changement de ligne + drawer.
   Les mises à jour visuelles de la page /cart sont isolées dans lp-v405-cart-page-runtime.js. */
async function lpChangeCartLine(lineKey, quantity, options = {}) {
  if (!lineKey) return;
  const root = window.Shopify?.routes?.root || '/';
  const res = await fetch(`${root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity) || 0) })
  });
  if (!res.ok) throw new Error('Mise à jour du panier impossible');
  const cart = await res.json();

  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
    el.hidden = cart.item_count === 0;
  });
  document.querySelectorAll('[data-cart-menu-count]').forEach(el => {
    el.textContent = `(${cart.item_count})`;
    el.hidden = cart.item_count === 0;
  });

  if (options.drawer) {
    await lpRefreshPremiumCart();
  } else {
    document.dispatchEvent(new CustomEvent('lp:cart:page-update', { detail: { cart, lineKey } }));
  }
  document.dispatchEvent(new CustomEvent('lp:cart:updated', { detail: { cart } }));
  return cart;
}

document.addEventListener('click', async e => {
  const minus = e.target.closest('[data-cart-qty-minus]');
  const plus = e.target.closest('[data-cart-qty-plus]');
  const remove = e.target.closest('[data-cart-remove]');
  if (!minus && !plus && !remove) return;

  const control = (minus || plus)?.closest('[data-cart-qty]');
  const lineKey = remove?.dataset.lineKey || control?.dataset.lineKey;
  const current = Number(control?.dataset.quantity || control?.querySelector('[data-cart-qty-value]')?.textContent || 0);
  const next = remove ? 0 : Math.max(0, current + (plus ? 1 : -1));
  const inDrawer = !!e.target.closest('[data-cart-drawer]');

  const buttons = (control ? [...control.querySelectorAll('button')] : []).concat(remove ? [remove] : []);
  const pageLine = e.target.closest('[data-cart-page-line]');
  if (pageLine) pageLine.classList.add('is-updating');
  buttons.forEach(b => b && (b.disabled = true));

  try {
    await lpChangeCartLine(lineKey, next, { drawer: inDrawer });
  } catch (err) {
    console.error('LE PIONNEZ cart change error', err);
    document.dispatchEvent(new CustomEvent('lp:cart:error', { detail: { message: 'La mise à jour du panier a échoué. Réessayez.' } }));
    if (pageLine) pageLine.classList.remove('is-updating');
    buttons.forEach(b => b && (b.disabled = false));
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lp-faq-footer').forEach(function (faq) {
    var toggle = faq.querySelector('.lp-faq-mobile-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var open = faq.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      var label = toggle.querySelector('span:first-child');
      if (label) label.textContent = open ? 'Masquer la FAQ' : 'Voir la FAQ';
    });
  });
});


/* V405 — interactions Maisons chargées uniquement sur accueil / pages Maison. */

/* V229 — close quarter-screen navigation with Escape */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !document.documentElement.classList.contains('lp-menu-open')) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  if (menu) {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
  }
  if (backdrop) backdrop.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('lp-menu-open');
  const opener = document.querySelector('[data-mobile-menu-open]');
  opener?.setAttribute('aria-expanded', 'false');
  opener?.focus();
  window.setTimeout(() => {
    if (menu && !menu.classList.contains('is-open')) menu.hidden = true;
    if (backdrop && !document.documentElement.classList.contains('lp-menu-open')) backdrop.hidden = true;
  }, 320);
});


/* V405 — focus clavier contenu dans le menu mobile ouvert. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab' || !document.documentElement.classList.contains('lp-menu-open')) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu || menu.hidden || menu.getAttribute('aria-hidden') === 'true') return;
  const focusable = [...menu.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')]
    .filter(el => !el.hidden && el.getClientRects().length);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

/* V405 — fermeture légère du menu mobile lors d'une navigation. */
document.addEventListener('click', event => {
  const link = event.target.closest('[data-mobile-menu] a[href]');
  if (!link) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  if (menu) {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden','true');
    menu.hidden = true;
  }
  if (backdrop) {
    backdrop.setAttribute('aria-hidden','true');
    backdrop.hidden = true;
    backdrop.style.pointerEvents = 'none';
  }
  document.documentElement.classList.remove('lp-menu-open');
  document.querySelectorAll('[data-mobile-menu-open]').forEach(el => el.setAttribute('aria-expanded','false'));
});

/* V405 — normalisation overlays centralisée dans interaction-safety. */

/* V404 — Gestion des cookies depuis le footer */
(() => {
  const openCookiePreferences = async () => {
    try {
      const banner = window.privacyBanner || (typeof privacyBanner !== 'undefined' ? privacyBanner : null);
      if (banner && typeof banner.showPreferences === 'function') {
        await banner.showPreferences();
        return true;
      }
    } catch (error) {
      console.error('LE PIONNEZ cookie preferences error', error);
    }
    return false;
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-lp-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    await openCookiePreferences();
  });
})();
;

/* ===== lp-v405-interaction-safety.js ===== */
(() => {
  const normalize = () => {
    const root = document.documentElement;

    const menu = document.querySelector('[data-mobile-menu]');
    const menuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');
    const menuOpen = Boolean(menu && !menu.hidden && menu.classList.contains('is-open'));
    if (!menuOpen) {
      root.classList.remove('lp-menu-open');
      if (menu) {
        menu.setAttribute('aria-hidden', 'true');
        if (!menu.classList.contains('is-open')) menu.hidden = true;
      }
      if (menuBackdrop) {
        menuBackdrop.hidden = true;
        menuBackdrop.setAttribute('aria-hidden', 'true');
        menuBackdrop.style.pointerEvents = 'none';
      }
      document.querySelectorAll('[data-mobile-menu-open]').forEach(el => el.setAttribute('aria-expanded','false'));
    }

    const drawer = document.querySelector('[data-cart-drawer]');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartOpen = Boolean(drawer && drawer.classList.contains('is-open'));
    if (!cartOpen && cartOverlay) {
      cartOverlay.hidden = true;
      cartOverlay.setAttribute('aria-hidden', 'true');
      cartOverlay.style.pointerEvents = 'none';
    }

    const searchDrawer = document.querySelector('[data-search-drawer]');
    const searchBackdrop = document.querySelector('[data-search-drawer-backdrop]');
    const searchOpen = Boolean(searchDrawer && !searchDrawer.hidden && searchDrawer.classList.contains('is-open'));
    if (!searchOpen) {
      if (searchDrawer) {
        searchDrawer.hidden = true;
        searchDrawer.setAttribute('aria-hidden','true');
      }
      if (searchBackdrop) {
        searchBackdrop.hidden = true;
        searchBackdrop.classList.remove('is-open');
        searchBackdrop.style.pointerEvents = 'none';
      }
      document.querySelectorAll('[data-search-drawer-open]').forEach(el => el.setAttribute('aria-expanded','false'));
    }

    const compare = document.querySelector('[data-compare-modal]');
    if (compare && compare.hidden) {
      compare.setAttribute('aria-hidden','true');
      document.body.classList.remove('lp-compare-open');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize, {once:true});
  } else {
    normalize();
  }

  window.addEventListener('pageshow', normalize);

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(normalize, 120);
  }, {passive:true});
})();
;
